export default __webpack_public_path__ + "static/media/defaultEmpty.a0841f55.jpeg";